import { m } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import { varHover } from 'src/components/animate';
import { useSnackbar } from 'src/components/snackbar';
import CustomPopover, { usePopover } from 'src/components/custom-popover';
import React, { useState, useEffect } from 'react';
import { getUserInfo } from 'src/_core/config/work-request-config';
// ----------------------------------------------------------------------

const OPTIONS = [
  // {
  //   label: 'Dashboard',
  //   linkTo: paths.dashboard.work_request.list,
  // },
  {
    label: 'Profile',
    linkTo: paths.dashboard.user.profile,
  },
  // {
  //   label: 'Tech Dashboard',
  //   linkTo: paths.dashboard.user.TechDashboard,
  // },
  
  // {
  //   label: 'Settings',
  //   linkTo: paths.dashboard.user.account,
  // },
];

// ----------------------------------------------------------------------

export default function AccountPopover() {

  const userName = localStorage.getItem('employeeName');

  const router = useRouter();

  const { logout } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const popover = usePopover();

  const [photourl, setimg] = useState('');

  const handleLogout = async () => {
    try {
      // Clear date filters before logout
      localStorage.setItem('userLoggedOut', 'true');
      window.dispatchEvent(new CustomEvent('userLogout'));
      
      await logout();
      popover.onClose();
      
      localStorage.removeItem('loginId');
      localStorage.removeItem('siteCode');
      localStorage.removeItem('employeeName');

      // Clear date filter related localStorage items
      localStorage.removeItem('dateFilter_from');
      localStorage.removeItem('dateFilter_to');
      localStorage.removeItem('firstFrom');

      router.replace('/');
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  const handleClickItem = (path) => {
    popover.onClose();
    router.push(path);
  };

  useEffect(() => {
    const fetchUserImage = async () => {
      try {
        const response = await getUserInfo({
          site_cd: localStorage.getItem('siteCode'), 
          login_id: localStorage.getItem('loginId'),
          mst_rowID: 0,
          isCreatingWorkReq: false,
          workRequestNumber: ''
          });
  
        if (response.data.status === 'SUCCESS') {
          const query4 = response.data.data.query4_response?.[0];
  
          if (query4?.attachment) {
            const base64Image = `data:image/png;base64,${query4.attachment}`;
            setimg(base64Image);
          } else {
            setimg('');
          }
        }
      } catch (error) {
        console.error('Error fetching user image:', error);
      }
    };
  
    fetchUserImage();
  }, []);
  

  

  return (
    <>
      <IconButton
        component={m.button}
        whileTap="tap"
        whileHover="hover"
        variants={varHover(1.05)}
        onClick={popover.onOpen}
        sx={{
          width: 40,
          height: 40,
          background: (theme) => alpha(theme.palette.grey[500], 0.08),
          ...(popover.open && {
            background: (theme) =>
              `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
          }),
        }}
      >
        <Avatar
          src={photourl || undefined}
          alt={userName}
          sx={{
            width: 36,
            height: 36,
            fontSize: '1rem',
            fontWeight: 100,
            bgcolor: (theme) => theme.palette.primary.main,
            color: '#fff',
          }}
        >
          {!photourl && userName
            ?.split(' ')
            .slice(0, 2)
            .map((n) => n[0]?.toUpperCase())
            .join('')
          }
        </Avatar>


      </IconButton>

      <CustomPopover open={popover.open} onClose={popover.onClose} sx={{ width: 200, p: 0 }}>
        <Box sx={{ p: 2, pb: 1.5 }} >
          <Typography variant="subtitle2" noWrap>
            {userName}
          </Typography>

        </Box>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <Stack sx={{ p: 1 }}>
          {OPTIONS.map((option) => (
            <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
              {option.label}
            </MenuItem>
          ))}
        </Stack>

        <Divider sx={{ borderStyle: 'dashed' }} />

        <MenuItem
          onClick={handleLogout}
          sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
        >
          Logout
        </MenuItem>
      </CustomPopover>
    </>
  );
}
